import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";
const PRAYERS = "PRAYERS";
const PRAYER = "PRAYER";
const apiFetcher = new ApiFetcher();
export function* fetchPrayers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `prayers?${queryString}`);
    yield put({
      type: sagaListSuccess(PRAYERS),
      data: res.data
    });
  } catch (e) { }
}

export function* searchPrayers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `prayers?${queryString}`);
    yield put({
      type: sagaSearchSuccess(PRAYERS),
      data: res.data
    });
  } catch (e) { }
}

export function* fetchPrayer(action) {
  try {
    const res = yield call(apiFetcher.find, "prayers", action.id);
    yield put({
      type: sagaOneSuccess(PRAYER),
      data: res.data
    });
  } catch (e) { }
}

export function* createPrayer(action) {
  try {
    const res = yield call(apiFetcher.create, "prayers", { prayer: action.data });
    yield put({
      type: sagaCreateSuccess(PRAYER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Prayer created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) { }
}

export function* updatePrayer(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "prayers",
      { prayer: action.data },
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(PRAYER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Prayer details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) { }
}



// WEBPACK FOOTER //
// ./src/sagas/prayers.js